import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  IHrHolidayCalendarPaginatedResponse,
  getHrHolidayCalendarListPaginated,
} from "api";
import { Nullable } from "config";
import { store } from "store";

import { HrHolidayCalendarModalMode } from "./enums";
import { IHrHolidayCalendarModalData } from "./types";

const initialState = {
  hrHolidayCalendarData: null as Nullable<
    IHrHolidayCalendarPaginatedResponse["edges"]
  >,
  totalCount: 1,
  loading: false,
  modalData: {
    mode: HrHolidayCalendarModalMode.VIEW,
    open: false,
    loading: false,
  } as IHrHolidayCalendarModalData,
};

export const fetchHrHolidayCalendarList = createAsyncThunk(
  "hr/fetchHrHolidayCalendarList",
  async () => {
    const filters = store.getState().FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const response = await getHrHolidayCalendarListPaginated(filters);
    return response;
  }
);

const hrHolidayCalendarSlice = createSlice({
  name: "hrHolidayCalendar",
  initialState,
  reducers: {
    setHrHolidayCalendarModalData: (
      state,
      action: PayloadAction<IHrHolidayCalendarModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeHrHolidayCalendarModal: (state) => {
      state.modalData = initialState.modalData;
    },
    setHrHolidayCalendarModalLoading: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.modalData.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchHrHolidayCalendarList.fulfilled, (state, action) => {
      if (!action.payload) return;
      return {
        ...state,
        hrHolidayCalendarData: action.payload
          ?.edges as IHrHolidayCalendarPaginatedResponse["edges"],
        totalCount: action.payload?.totalCount,
        loading: false,
      };
    });
    builder.addCase(fetchHrHolidayCalendarList.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const {
  setHrHolidayCalendarModalData,
  closeHrHolidayCalendarModal,
  setHrHolidayCalendarModalLoading,
} = hrHolidayCalendarSlice.actions;

export default hrHolidayCalendarSlice.reducer;
